import get from 'lodash/get'
import has from 'lodash/has'
import set from 'lodash/set'

import MigrationShouldRun from 'api/migrate/MigrationShouldRun'
import UpdateVersion from 'api/migrate/UpdateVersion'

/**
 * Run the migration if version is less than the config.
 *
 * @param {Object} config
 */
export default function (config) {
  const MIGRATION_TO_VERSION = 2

  if (MigrationShouldRun(config, MIGRATION_TO_VERSION)) {
    // Run migration scripts here...
    const layers = get(config, 'layers', [])
    for (const key in layers) {
      const layer = layers[key]
      let bEnabled = false
      if (has(layer, 'search.enabled')) {
        continue
      } else if (!has(layer, 'search')) {
        bEnabled = false
      } else if (get(layer, 'search.id', '') !== '') {
        bEnabled = true
      } else if (get(layer, 'search.titlecase', '') !== '') {
        bEnabled = true
      } else if (has(layer, 'search.enableLayer')) {
        bEnabled = get(layer, 'search.enableLayer', false)
      } else {
        bEnabled = false
      }
      setSearchEnabledFlag(config, key, bEnabled)
    }

    UpdateVersion(config, MIGRATION_TO_VERSION)
  }

  return config
}

function setSearchEnabledFlag (config, layerKey, bEnabled) {
  set(config, `layers[${layerKey}].search.enabled`, bEnabled)
}
